import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { StyleType } from "@omni/ui/components/CallToAction/types/enums/styleType.enum";
import { Style } from "@omni/ui/components/CallToAction/types/style";
import { cn } from "@omni/utils/styles";

export const createAnchorStyleProperties = (style: Style) => {
    if (style.styleType === StyleType.BUTTON) {
        const { color, outline, fullWidth, size } = style;

        const colorClass = `btn${outline ? "-outline" : ""}-${
            color ?? "primary"
        }`;
        const sizeClass = `btn-${size}`;
        const widthClass = fullWidth ? "btn-block" : undefined;

        return {
            className: cn("btn", colorClass, sizeClass, widthClass)
        };
    }

    if (style.styleType === StyleType.TITLE) {
        const { color, underline, headingLevel } = style;

        const colorClass = color ? `text-${color}` : undefined;
        const underlineClass =
            underline === "always"
                ? "text-decoration-underline"
                : underline === "never"
                  ? "text-decoration-none"
                  : undefined;
        const headingClass = headingLevel
            ? `heading-${headingLevel}`
            : undefined;

        return {
            className: cn(colorClass, underlineClass, headingClass)
        };
    }

    if (style.styleType === StyleType.LINK) {
        return {
            className: "link"
        };
    }
};

export const createButtonStyleProperties = (
    style: Style
): Partial<ButtonComponentProps> | undefined => {
    if (style.styleType === StyleType.BUTTON) {
        const { color, outline, fullWidth, size } = style;

        return {
            color: color ?? "primary",
            outline: outline,
            fullWidth: fullWidth,
            size: size
        };
    }

    if (style.styleType === StyleType.TITLE) {
        const { color, underline, headingLevel } = style;

        const colorClass = color ? `text-${color}` : undefined;
        const underlineClass =
            underline === "always"
                ? "text-decoration-underline"
                : underline === "never"
                  ? "text-decoration-none"
                  : undefined;
        const headingClass = headingLevel
            ? `heading-${headingLevel}`
            : undefined;

        return {
            color: "link",
            className: cn(colorClass, underlineClass, headingClass)
        };
    }

    if (style.styleType === StyleType.LINK) {
        return {
            color: "link",
            className: "link"
        };
    }
};
